import * as yup from "yup"

export default yup.object().shape({
  role: yup
    .number()
    .required("Must choose role"),
  email: yup
    .string()
    .email("Must provide a valid email")
    .required("Must provide a valid email"),
  display_name: yup
    .string()
    .required("Must provide a name (min. 2 char.)")
    .min(2, "Must provide a name (min. 2 char.)")
    .max(25, "Must provide a name (max 25 char.)"),
  phone: yup
    .string(),
  password: yup
    .string()
    .required("Must provide a password (min. 5 char.)")
    .min(5, "Must provide a password (min. 5 char.)"),
  password_confirm: yup
    .string()
    .required("Passwords must match (min. 5 char.)")
    .min(5, "Passwords must match (min. 5 char.)"),
  sec_question: yup
    .string()
    .required("Must select a security question")
    .min(1, "Must select a security question"),
  sec_answer: yup
    .string()
    .required("Must provide a security question answer (min. 3 char.)")
    .min(3, "Must provide a security question answer (min. 3 char.)")
})
